/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useCallback } from 'react';
import { func, bool } from 'prop-types';
import debounce from 'lodash/debounce';
import IconSearch from '../../shared/icons/IconSearch';
import IconClose from '../../shared/icons/IconClose';

const SearchBox = ({ onChange, disabled = false }) => {
  const [value, setValue] = useState('');
  const [focus, setFocus] = useState(false);

  const _handleOnChange = searchValue => {
    onChange(searchValue.trim(), 'searchText');
  };

  const delayedQuery = useCallback(
    debounce(q => _handleOnChange(q), 500),
    []
  );

  const onInputChange = searchValue => {
    setValue(searchValue);
    delayedQuery(searchValue);
  };

  return (
    <div
      className={`de--search--input--root ${
        disabled ? 'de--search--input--root--disabled' : ' '
      }
      ${focus ? 'de--search--input--root--active' : ''}`}
    >
      {!value && (
        <label
          htmlFor="campaignTargetSearch"
          className="de--search--input--icon"
        >
          <IconSearch />
        </label>
      )}
      <div className="de--search--input">
        <input
          id="campaignTargetSearch"
          name="campaignTargetSearch"
          type="text"
          placeholder="Search by target name or study"
          className="de--search--input--field"
          value={value}
          onChange={e => onInputChange(e.target.value)}
          disabled={disabled}
          autoComplete="off"
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
        />
      </div>
      {value && (
        <div className="de--search--input--icon">
          <button
            type="button"
            onClick={() => onInputChange('')}
            title="clear search"
            className="de--search--input--icon-btn"
          >
            <IconClose />
          </button>
        </div>
      )}
    </div>
  );
};

SearchBox.propTypes = {
  onChange: func.isRequired,
  disabled: bool,
};

export default SearchBox;
